import { render, staticRenderFns } from "./apartment-additional-cost-features.vue?vue&type=template&id=b94f9d60&"
import script from "./apartment-additional-cost-features.ts?vue&type=script&lang=ts&"
export * from "./apartment-additional-cost-features.ts?vue&type=script&lang=ts&"
import style0 from "./apartment-additional-cost-features.scss?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports